import { render, staticRenderFns } from "./pattern-suggestions.vue?vue&type=template&id=1d7bcb7c&"
import script from "./pattern-suggestions.vue?vue&type=script&lang=js&"
export * from "./pattern-suggestions.vue?vue&type=script&lang=js&"
import style0 from "./pattern-suggestions.vue?vue&type=style&index=0&id=1d7bcb7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports